import React from 'react';
import Chart from '../molecules/Chart'
import DelayValue from '../molecules/DelayValue'

const ChartsRow = (props) => {
    const { title, data, loading, xAxisType, type, className, delayShipments, totalShipments }  = props;

    let extra;
    if (type === 'orderPerformance') {
        extra = (
            <DelayValue
                className="mb-4"
                delay={delayShipments}
                total={totalShipments}
            />
        )
    }

    return (
        <div className={`${className} bg-white rounded shadow p-4`}>
            <h5>{title}</h5>
            <br/>
            { extra }
            <Chart
                type={type}
                xAxisType={xAxisType}
                data={data}
                loading={loading}
            />
        </div>
    );
};

export default ChartsRow;
